export const ROUTES = {
    NOT_FOUND: "/not-found",
    LAYANAN_KAMI: "/layanan-kami",
    TENTANG_KAMI: "/tentang-kami",
    JASA_TUKANG:"/jasa-tukang",
    KOTA_LAYANAN:"/kota-layanan",
    KONSULTASI:"/konsultasi",
    
  };
  